export default __webpack_public_path__ + "static/media/knorr-brense-parekh-agencies.3ec73f31.webp";